/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A condition raised against the freight itself. These are the flags a
 * carrier can act on; the operator and customer flags are internal or
 * customer-facing and are never sent here.
 *
 * @export
 */
export const ShipmentFlagType = {
  Missing: "freight_missing",
  Shortage: "freight_shortage",
  Damaged: "freight_damaged",
} as const;
export type ShipmentFlagType =
  (typeof ShipmentFlagType)[keyof typeof ShipmentFlagType];

export function instanceOfShipmentFlagType(value: any): boolean {
  for (const key in ShipmentFlagType) {
    if (Object.prototype.hasOwnProperty.call(ShipmentFlagType, key)) {
      if (ShipmentFlagType[key as keyof typeof ShipmentFlagType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentFlagTypeFromJSON(json: any): ShipmentFlagType {
  return ShipmentFlagTypeFromJSONTyped(json, false);
}

export function ShipmentFlagTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentFlagType {
  return json as ShipmentFlagType;
}

export function ShipmentFlagTypeToJSON(value?: ShipmentFlagType | null): any {
  return value as any;
}

export function ShipmentFlagTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentFlagType {
  return value as ShipmentFlagType;
}
